import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Icon as SvgIcon } from '@gymondo/frontend-core/components'

import style from './icon.module.scss'

const Icon = ({ className, svg, title, subtitle }) => (
    <div className={cn(style.wrapper, className)}>
        <SvgIcon className={style.svg} data={svg} />
        <div className={style.title}>
            <FormattedMessage id={title} />
        </div>
        <div className={style.subtitle}>
            <FormattedMessage id={subtitle} />
        </div>
    </div>
)

Icon.propTypes = {
    className: PropTypes.string,
    svg: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
}

Icon.defaultProps = {
    className: null,
}

export default Icon
